export default __webpack_public_path__ + "static/media/ads-chancellor-01.b6214910.gif";